import axios from "axios";

const headers = (token) => ({
  "Content-Type": "application/json ",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

const buildQuery = (params = {}) => {
  const query = Object.keys(params)
    .filter((key) => params[key] !== "" && params[key] !== null && params[key] !== undefined)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join("&");

  return query ? `?${query}` : "";
};

const baseUrl = `${process.env.REACT_APP_NOT_SECRET_CODE}/lead-retention`;

export const getLeadRetentionProfiles = (token, params = {}) =>
  axios.get(baseUrl + buildQuery(params), { headers: headers(token) }).then((res) => res.data);

export const getLeadRetentionProfile = (token, leadId) =>
  axios.get(`${baseUrl}/${leadId}`, { headers: headers(token) }).then((res) => res.data);

export const getLeadRetentionAnalytics = (token, params = {}) =>
  axios.get(`${baseUrl}/analytics` + buildQuery(params), { headers: headers(token) }).then((res) => res.data);

export const downloadLeadRetentionExport = (token, params = {}) =>
  axios.get(`${baseUrl}/export` + buildQuery(params), {
    headers: headers(token),
    responseType: "blob",
  });

export const startLeadRetentionRefresh = (token, body = {}) =>
  axios.post(`${baseUrl}/refresh`, body, { headers: headers(token) }).then((res) => res.data);

export const getLeadRetentionRefreshRun = (token, runId) =>
  axios.get(`${baseUrl}/refresh/${runId}`, { headers: headers(token) }).then((res) => res.data);

export const previewLeadRetentionCampaign = (token, body = {}) =>
  axios.post(`${baseUrl}/campaign/preview`, body, { headers: headers(token) }).then((res) => res.data);

export const sendLeadRetentionCampaign = (token, body = {}) =>
  axios.post(`${baseUrl}/campaign/send`, body, { headers: headers(token) }).then((res) => res.data);

export const getLeadRetentionCampaignStatus = (token, campaignId) =>
  axios.get(`${baseUrl}/campaign/${campaignId}`, { headers: headers(token) }).then((res) => res.data);

export const getLeadRetentionCampaigns = (token, params = {}) =>
  axios.get(`${baseUrl}/campaigns` + buildQuery(params), { headers: headers(token) }).then((res) => res.data);

export const getLeadRetentionCampaignDetails = (token, campaignId) =>
  axios.get(`${baseUrl}/campaigns/${campaignId}`, { headers: headers(token) }).then((res) => res.data);
